import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaTimes, FaChevronDown } from 'react-icons/fa';

const serviceNavItems = [
  { label: 'Website', to: '/services#website' },
  { label: 'SEO', to: '/services#seo' },
  { label: 'AI Automations', to: '/services#ai-automations' },
  { label: 'Customized Software', to: '/custom-software' },
];

const opportunityNavItems = [
  { label: 'Earn Money through Our Referral Program', to: '/offers#referral-program' },
  { label: 'Client Discounts', to: '/offers#client-discounts' },
];

const navLinkClass =
  'text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const [isMobileOpportunitiesOpen, setIsMobileOpportunitiesOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isMobileMenuOpen) {
      setIsMobileServicesOpen(false);
      setIsMobileOpportunitiesOpen(false);
    }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
    setIsMobileOpportunitiesOpen(false);
  };

  const textShadowStyle = {
    textShadow: `
      -0.3px -0.3px 0 #292929,
      0.3px -0.3px 0 #292929,
      -0.3px 0.3px 0 #292929,
      0.3px 0.3px 0 #292929,
      0 -0.3px 0 #292929,
      0 0.3px 0 #292929,
      -0.3px 0 0 #292929,
      0.3px 0 0 #292929
    `
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50">
      {/* Main Navigation */}
      <div className="max-w-7xl mx-auto px-4">
          {/* Top Row - Logo and Main Links */}
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center">
              <img 
                src="/WNlogo.png" 
                alt="WN Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block" style={{ 
                fontFamily: "'Poppins', sans-serif"
              }}>Home</Link>
              <div className="relative group">
                <Link
                  to="/services"
                  className={navLinkClass}
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Services
                </Link>
                <div
                  className="absolute left-0 top-full pt-2 z-50 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-200 pointer-events-none group-hover:pointer-events-auto"
                >
                  <div
                    className="rounded-2xl border border-[#ff7a59]/30 shadow-xl py-2 min-w-[220px]"
                    style={{
                      backgroundColor: 'rgba(255, 252, 240, 0.97)',
                      backdropFilter: 'blur(12px)',
                    }}
                  >
                    {serviceNavItems.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        className="block px-4 py-2.5 text-sm text-gray-700 hover:text-[#ff7a59] hover:bg-[#ff7a59]/10 transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="relative group">
                <Link
                  to="/offers"
                  className={navLinkClass}
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Opportunities
                </Link>
                <div
                  className="absolute left-0 top-full pt-2 z-50 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-200 pointer-events-none group-hover:pointer-events-auto"
                >
                  <div
                    className="rounded-2xl border border-[#ff7a59]/30 shadow-xl py-2 min-w-[280px]"
                    style={{
                      backgroundColor: 'rgba(255, 252, 240, 0.97)',
                      backdropFilter: 'blur(12px)',
                    }}
                  >
                    {opportunityNavItems.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        className="block px-4 py-2.5 text-sm text-gray-700 hover:text-[#ff7a59] hover:bg-[#ff7a59]/10 transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <Link to="/accessibility" className="text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block" style={{ 
                fontFamily: "'Poppins', sans-serif"
              }}>ADA</Link>
              <Link to="/book" className="text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block" style={{ 
                fontFamily: "'Poppins', sans-serif"
              }}>Book</Link>
              <Link to="/aboutme" className="text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block" style={{ 
                fontFamily: "'Poppins', sans-serif"
              }}>About</Link>
              <Link to="/contactme" className="text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 inline-block" style={{ 
                fontFamily: "'Poppins', sans-serif"
              }}>Contact</Link>
            </div>
          </div>

          {/* Bottom Row - Contact Info and Social Media (Desktop Only) */}
          <div className="hidden md:flex items-center justify-between py-2">
            {/* Contact Information */}
            <div className="flex items-center space-x-6">
              <a href="mailto:zarafairooz@webanova.studio" className="flex items-center text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5">
                <FaEnvelope className="w-4 h-4 mr-2" />
                <span className="text-sm" style={{ 
                  fontFamily: "'Poppins', sans-serif"
                }}>zarafairooz@webanova.studio</span>
              </a>
              <a href="tel:8186419709" className="flex items-center text-gray-700 hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5">
                <FaPhone className="w-4 h-4 mr-2" />
                <span className="text-sm" style={{ 
                  fontFamily: "'Poppins', sans-serif"
                }}>(818) 641-9709</span>
              </a>
            </div>

          </div>
        </div>

      {/* Mobile Menu Button */}
      <button 
        onClick={toggleMobileMenu}
        className="md:hidden absolute top-4 right-4 z-50 text-gray-700 hover:text-[#ff7a59] transition-colors"
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? (
          <FaTimes className="w-6 h-6" />
        ) : (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/50 z-30"
          onClick={toggleMobileMenu}
        ></div>
      )}

      {/* Mobile Menu */}
      <div 
        className={`md:hidden fixed top-0 left-0 w-full h-screen bg-black/95 backdrop-blur-sm transition-transform duration-300 ease-in-out z-40 ${
          isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full pt-20 px-6">
          {/* Navigation Links */}
          <div className="flex flex-col space-y-6 mb-8">
            <Link 
              to="/" 
              onClick={closeMobileMenu}
              className="text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105" 
              style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}
            >
              Home
            </Link>
            <div>
              <button
                type="button"
                onClick={() => setIsMobileServicesOpen((open) => !open)}
                className="flex items-center gap-2 text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  ...textShadowStyle,
                }}
                aria-expanded={isMobileServicesOpen}
              >
                Services
                <FaChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${isMobileServicesOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {isMobileServicesOpen && (
                <div className="mt-4 ml-2 flex flex-col space-y-3 border-l-2 border-[#ff7a59]/40 pl-4">
                  <Link
                    to="/services"
                    onClick={closeMobileMenu}
                    className="text-lg text-[#fffcf0] hover:text-[#ff7a59] transition-colors"
                    style={{ fontFamily: "'Poppins', sans-serif", ...textShadowStyle }}
                  >
                    All services
                  </Link>
                  {serviceNavItems.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={closeMobileMenu}
                      className="text-lg text-[#fffcf0] hover:text-[#ff7a59] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif", ...textShadowStyle }}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div>
              <button
                type="button"
                onClick={() => setIsMobileOpportunitiesOpen((open) => !open)}
                className="flex items-center gap-2 text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  ...textShadowStyle,
                }}
                aria-expanded={isMobileOpportunitiesOpen}
              >
                Opportunities
                <FaChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${isMobileOpportunitiesOpen ? 'rotate-180' : ''}`}
                />
              </button>
              {isMobileOpportunitiesOpen && (
                <div className="mt-4 ml-2 flex flex-col space-y-3 border-l-2 border-[#ff7a59]/40 pl-4">
                  <Link
                    to="/offers"
                    onClick={closeMobileMenu}
                    className="text-lg text-[#fffcf0] hover:text-[#ff7a59] transition-colors"
                    style={{ fontFamily: "'Poppins', sans-serif", ...textShadowStyle }}
                  >
                    All opportunities
                  </Link>
                  {opportunityNavItems.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={closeMobileMenu}
                      className="text-lg text-[#fffcf0] hover:text-[#ff7a59] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif", ...textShadowStyle }}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link 
              to="/accessibility" 
              onClick={closeMobileMenu}
              className="text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105" 
              style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}
            >
              ADA
            </Link>
            <Link 
              to="/book" 
              onClick={closeMobileMenu}
              className="text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105" 
              style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}
            >
              Book
            </Link>
            <Link 
              to="/aboutme" 
              onClick={closeMobileMenu}
              className="text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105" 
              style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}
            >
              About
            </Link>
            <Link 
              to="/contactme" 
              onClick={closeMobileMenu}
              className="text-2xl text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105" 
              style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}
            >
              Contact
            </Link>
          </div>

          {/* Divider */}
          <div className="border-t border-white/10 my-6"></div>

          {/* Contact Information */}
          <div className="flex flex-col space-y-4 mb-6">
            <a 
              href="mailto:zarafairooz@webanova.studio" 
              onClick={closeMobileMenu}
              className="flex items-center text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105"
            >
              <FaEnvelope className="w-5 h-5 mr-3" />
              <span className="text-lg" style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}>zarafairooz@webanova.studio</span>
            </a>
            <a 
              href="tel:8186419709" 
              onClick={closeMobileMenu}
              className="flex items-center text-[#fffcf0] hover:text-[#ff7a59] transition-all duration-300 transform hover:scale-105"
            >
              <FaPhone className="w-5 h-5 mr-3" />
              <span className="text-lg" style={{ 
                fontFamily: "'Poppins', sans-serif",
                ...textShadowStyle
              }}>(818) 641-9709</span>
            </a>
          </div>

        </div>
      </div>
    </nav>
  );
} 